import React, { Component } from 'react'

import Modal from '../../atoms/Modal'
import Button from '../../atoms/Button'

import css from './style.module.css'

const body = document.body || document.documentElement

class Dialog extends Component {

    state = {
        active: false
    }

    keyAction(evt) {
        const keyCode = evt.keyCode  ? evt.keyCode  :
                      evt.charCode ? evt.charCode :
                      evt.which    ? evt.which    : void 0;
        
        if(keyCode === 27) {
            this.handleAction(false)
        }

        if(keyCode === 13) {
            this.handleAction(true)      
            evt.preventDefault()
            evt.stopPropagation()
        }
        
    }

    confirm(title, message) {
        body.addEventListener("keydown", this.keyAction.bind(this))
        return new Promise((resolve, reject) => {
            this.setState({
                title,
                message,
                action: { resolve, reject },
                actionCancel: true,
                active: true
            })
        })
    }

    alert(message) {
        body.addEventListener("keydown", this.keyAction.bind(this))
        return new Promise((resolve, reject) => {
            this.setState({
                title: "",
                message,
                action: { resolve, reject },
                actionCancel: false,
                active: true
            })
        })
    }

    handleAction(confirm) {
        body.removeEventListener("keydown", this.keyAction.bind(this))

        if(confirm)
        this.state.action.resolve()
        else
        this.state.action.reject()

        this.setState({
            title: '',
            message: '',
            action: null,
            active: false
        })
    }

    render() {
        const { active, title, message } = this.state

        if(!active) return null

        return (
            <Modal active hideClose style={{ padding: '20px', width: '400px' }}>
                <div className={css.dialog}>
                    <div className={css['dialog-title']}>{title}</div>
                    <div className={css['dialog-message']}>{message}</div>

                    <div className={css['btns']}>
                        {this.state.actionCancel && (
                            <div className={css.btn}>
                                <Button
                                    secondary
                                    onClick={() => this.handleAction(false)}
                                >Cancelar</Button>
                            </div>
                        )}
                        <div className={css.btn}>
                            <Button
                                primary
                                onClick={() => this.handleAction(true)}
                                >Ok</Button>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default Dialog


// WEBPACK FOOTER //
// ./src/v2SPRINTA/molecules/Dialog/index.js